import {ScrollDirectionEnum} from "../../../../types";
import gsap from "../../../../helpers/gsapInstance";
import MainPageService from "../../../../services/main-page/MainPageService";
import MainPageCommonService from "../../../../services/main-page/MainPageCommonService";
import MainPageFirstScreenCommon from "./MainPageFirstScreenCommon";

export default class MainPageFirstScreenDesktop extends MainPageCommonService {
    private readonly $holder: JQuery;
    public $secondScreenContainer: JQuery;

    public readonly $screen: JQuery;
    public readonly $mainPoint: JQuery;

    // Важно! Если меняешь здесь, то также меняй значение scss переменной $main-page-hero-main-image-y-offset-desktop в файле variables.scss !
    public readonly MAIN_POINT_STARTS_Y_DIRECTION_PIXELS: number = 110;

    public readonly SCALE_COEFFICIENT: number = ((window.innerHeight / window.innerWidth) > 0.5) ? 0.7 : 0.85;

    constructor($holder: JQuery) {
        super();

        this.$holder = $holder;

        this.$screen = this.$holder.find(MainPageFirstScreenCommon.selectors.screen);
        this.$mainPoint = this.$screen.find(MainPageFirstScreenCommon.selectors.mainPoint);

        this.setMainPointAnimation = this.setMainPointAnimation.bind(this);
    }

    /**
     * Включение анимации на первом экране с бутылочкой
     * @public
     * @param direction
     */
    public setMainPointAnimation(direction: ScrollDirectionEnum): void {
        const tl = gsap.timeline();

        // Высота элемента картинки с бутылочкой
        const mainPointHeight = this.$mainPoint.outerHeight();
        // Высота контента на второй секции, не учитывая верхний padding на header, чтобы найти полную высоту экрана с кругом внутри, куда приезжает бутылочка
        const secondScreenInnerContainerHeight = this.$secondScreenContainer.outerHeight()
        // Просчитанная высота (высота экрана - половина внутреннего контента второй секции + половина картинки с бутылочкой)
        const calculatedTranslateYToBottom = window.innerHeight - (secondScreenInnerContainerHeight / 2) + (mainPointHeight / 2);

        if (direction === ScrollDirectionEnum.DOWN) {
            tl.addLabel('START')
                .addLabel('TRANSFORM_Y_TO_BOTTOM_AND_SCALE')
                .to(this.$mainPoint, {
                    duration: this.QUARTER_ANIMATION_DURATION * 3,
                    translateY: `${calculatedTranslateYToBottom}px`,
                    scale: this.SCALE_COEFFICIENT
                })
                .addLabel('END');

        } else {
            const mainPointStartsOffset = this.MAIN_POINT_STARTS_Y_DIRECTION_PIXELS;
            const translateY = MainPageService.getConvertedValue(mainPointStartsOffset);

            tl.addLabel('START')
                .addLabel('TRANSFORM_Y_TO_TOP_AND_SCALE')
                .to(this.$mainPoint, {
                    duration: this.QUARTER_ANIMATION_DURATION * 4,
                    translateY: `${translateY}px`,
                    scale: 1
                })
                .addLabel('END');
        }
    }

    /**
     * Обновить характеристики отступа бутылочки из 1 секции при resize
     * @public
     */
    public setMainPointOffset(): void {
        const mainPointStartsOffset = this.MAIN_POINT_STARTS_Y_DIRECTION_PIXELS;
        const translateY = MainPageService.getConvertedValue(mainPointStartsOffset);

        const styleValue = `translate(-50%, ${translateY}) scale(1, 1)`;

        this.$mainPoint.css({"transform": styleValue});
    }
}
